import { ExternalLink } from 'lucide-react';
import { ROUTES } from '../../routes/consts';
import { StepConfig } from '../../shared/MultiStepDialog';
import { spawn } from '../../utils/translations';
import { FORM_IDS, STEP_IDS } from './consts';
import { CarouselStepConfig } from './types';
import installAdminGuide from '/images/azure-installation/install-admin-guide.png';
import installGuide from '/images/azure-installation/install-guide.png';

const spawnSteps = spawn('dialogs.azure-installation.steps');

export const getSteps = (): StepConfig[] => [
  {
    id: STEP_IDS.CHOOSE_METHOD,
    path: ROUTES.AZURE_INSTALLATION_STEP_0,
    title: spawnSteps('installation-type.title'),
    shouldShowBackButton: false,
    shouldShowCancelButton: true,
    isNextInitiallyEnabled: false,
    nextLabel: spawnSteps('installation-type.next-label'),
    formId: FORM_IDS.CHOOSE_METHOD,
  },
  {
    id: STEP_IDS.REVIEW_MANIFEST,
    path: ROUTES.AZURE_INSTALLATION_STEP_1,
    title: spawnSteps('review-manifest.title'),
    shouldShowBackButton: true,
    shouldShowCancelButton: false,
    isNextInitiallyEnabled: false,
    nextLabel: spawnSteps('review-manifest.next-label'),
    disabledColor: 'var(--text-general-neutral-muted)',
  },
  {
    id: STEP_IDS.INSTALL_GUIDE,
    path: ROUTES.AZURE_INSTALLATION_STEP_2,
    title: spawnSteps('install-guide.title'),
    shouldShowBackButton: true,
    isNextInitiallyEnabled: true,
    nextLabel: spawnSteps('install-guide.next-label'),
    nextLabelIcon: ExternalLink,
    formId: FORM_IDS.INSTALL_GUIDE,
    disabledColor: 'var(--text-general-neutral-muted)',
  },
  {
    id: STEP_IDS.CONNECT_REPOS,
    path: ROUTES.AZURE_INSTALLATION_STEP_3,
    title: spawnSteps('connect-repos.title'),
    shouldShowBackButton: true,
    isNextInitiallyEnabled: false,
    nextLabel: spawnSteps('connect-repos.sync-button'),
    formId: FORM_IDS.CONNECT_REPOS,
  },
  {
    id: STEP_IDS.CHECK_CONNECTION,
    path: ROUTES.AZURE_INSTALLATION_STEP_4,
    title: spawnSteps('check-connection.title'),
    shouldShowBackButton: true,
    isNextInitiallyEnabled: true,
    nextLabel: spawnSteps('check-connection.next-label'),
  },
  {
    id: STEP_IDS.ENABLE_QODO,
    path: ROUTES.AZURE_INSTALLATION_STEP_5,
    title: spawnSteps('enable-qodo.title-enable'),
    shouldShowBackButton: true,
    isNextInitiallyEnabled: true,
    nextLabel: spawnSteps('enable-qodo.finish-label'),
  },
];

export const INSTALLATION_GUIDE_CAROUSEL_STEPS: CarouselStepConfig[] = [
  { id: 'azure-admin', image: installGuide },
  { id: 'ado-admin', image: installAdminGuide },
];
